import ResponseHelper from '@/helpers/responseHelper';
import api from '@/store/api';

/**
 * Returns a full subsystem tree with children
 * @param {*} param0
 * @param {*} subsystemId
 */
const getVenues = ({ commit }) => {
  const url = '/WebSite/VenueList';
  commit('setVenuesLoading', true);

  return api
    .get(url)
    .then((response) => {
      const valid = ResponseHelper.processResponse(
        response,
        commit,
        'getVenues'
      );

      if (valid) {
        commit('setVenues', response.data);
        return response.data;
      } else {
        return response.Errors;
      }
    })
    .finally(() => {
      commit('setVenuesLoading', false);
    });
};

/**
 * Returns a full subsystem tree with children
 * @param {*} param0
 * @param {*} subsystemId
 */
const getRelatedVenues = ({ commit }, venue) => {
  const url = '/WebSite/RelatedVenueList/' + venue;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(
      response,
      commit,
      'getRelatedVenues'
    );

    if (valid) {
      commit('setRelatedVenue', response.data);
      return response.data;
    } else {
      return response.Errors;
    }
  });
};

/**
 * Returns a full subsystem tree with children
 * @param {*} param0
 * @param {*} subsystemId
 */
const getVenueDetails = ({ commit }, venue) => {
  const url = '/WebSite/VenueDetails/' + venue;

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(
      response,
      commit,
      'VenueDetails'
    );

    if (valid) {
      commit('setCurrentVenue', response.data);
      return response.data;
    } else {
      return response.Errors;
    }
  });
};
// TODO: System Details standalone endpoint
// WebSite/SystemDetails/wirelessmicrophones
const getSystemDetails = ({ commit }, payload) => {
  let url = '/WebSite/SystemDetails/' + payload.systemName;
  if (payload.venueName) {
    url += '?venue=' + payload.venueName;
  }

  return api.get(url).then((response) => {
    const valid = ResponseHelper.processResponse(
      response,
      commit,
      'getSystemDetails'
    );

    if (valid) {
      return response.data;
    } else {
      return response.Errors;
    }
  });
};

export default {
  getVenues,
  getRelatedVenues,
  getVenueDetails,
  getSystemDetails
};
